import React from 'react'
import styled from 'styled-components'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { Button, Typography, Box } from '@material-ui/core'
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import PersonIcon from '@material-ui/icons/Person'

type ChangeOwnerDialogProps = {
  open: boolean
  onClose: () => void
}
type SimpleListProps = {
  users: UserType[]
}
const LabelTypography = styled(Typography)`
  color: #9e9e9e;
`

type UserType = {
  name: string
}

const Users: UserType[] = [
  {name: 'ユーザ１'},
  {name: 'ユーザ２'},
  {name: 'ユーザ３'},
  {name: 'ユーザ４'}
]

const SimpleList: React.FC<SimpleListProps> = (props) => {
  const {users} = props

  const [selectedIndex, setSelectedIndex] = React.useState(0)

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index)
  }

  return (
    <Box width="90%">
      <LabelTypography variant="caption">新しい所有者</LabelTypography>
      <List component="nav">
        {users.map((user, index) =>
          <ListItem key={index} button selected={selectedIndex === index}
            onClick={(event) => handleListItemClick(event, index)}>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary={user.name} key={user.name} />
          </ListItem>)}
      </List>
    </Box>
  )
}

const ChangeOwnerDialog:React.FC<ChangeOwnerDialogProps> = ({open, onClose}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>フォルダの所有者を変更します</DialogTitle>
      <DialogContent style={{overflow: 'hidden'}}>
        <SimpleList users={Users} />
        <Box mb={1}>
          <LabelTypography variant="caption">* 他の人に所有者を変更すると、あなたはこのフォルダの参加者になります。</LabelTypography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={onClose}>
          変更する
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ChangeOwnerDialog